import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Window, Button } from '@warmancer/ui';
import { authApi } from '../api/client';
import { useAuthStore } from '../stores/authStore';
import styles from './AuthPages.module.css';

export function Home() {
  const navigate = useNavigate();
  const account = useAuthStore((s) => s.account);
  const clearSession = useAuthStore((s) => s.clearSession);

  const logoutMutation = useMutation({
    mutationFn: () => authApi.logout(),
    onSuccess: () => {
      clearSession();
      navigate('/login');
    },
    onError: () => {
      // Even if the server-side logout fails, clear local session
      clearSession();
      navigate('/login');
    },
  });

  return (
    <Window title={`Welcome, ${account?.username || 'Player'}`} maxWidth={400} className={styles.window}>
      <div className={styles.form}>
        <div className={styles.formDescription}>
          <p>Email: {account?.email}</p>
          <p>Verified: {account?.email_verified ? 'Yes' : 'No'}</p>
        </div>
        <Button onClick={() => navigate('/game')}>
          Launch Game
        </Button>
        <Button
          onClick={() => logoutMutation.mutate()}
          loading={logoutMutation.isPending}
          disabled={logoutMutation.isPending}
        >
          Logout
        </Button>
      </div>
    </Window>
  );
}
